import { getTimeSinceDate } from '@airship-platform/airship-patterns';
import { FlexBox } from '@airship-platform/jam-web/components';
import Card from '@mui/material/Card';
import Divider from '@mui/material/Divider';
import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';
import { Fragment, type PropsWithChildren } from 'react';
import {
  formatDuration,
  type ProposalEngagement,
} from '../../../../data-access/proposalEngagement';

interface OwnProps {
  isLoading: boolean;
  engagement?: ProposalEngagement;
}

const statTilesOf = (engagement?: ProposalEngagement) => [
  {
    label: 'Total views',
    value: engagement?.totalPageViews ?? '-',
  },
  {
    label: 'Total time',
    value: engagement ? formatDuration(engagement.grandTotalMinutes) : '-',
  },
  {
    label: 'Last viewed',
    value:
      engagement?.lastViewedAt != null
        ? getTimeSinceDate(new Date(engagement.lastViewedAt).toISOString())
        : '-',
  },
];

const EngagementCard: React.FC<PropsWithChildren<OwnProps>> = ({
  isLoading,
  engagement,
  children,
}) => (
  <Card variant={'bordered'}>
    <FlexBox flexDirection={'column'} gap={2}>
      <FlexBox width={'100%'}>
        {statTilesOf(engagement).map((tile, index) => (
          <Fragment key={tile.label}>
            {index > 0 && <Divider orientation={'vertical'} flexItem />}
            <FlexBox flexDirection={'column'} flex={1} px={2}>
              <Typography variant={'body3'} color={'text.secondary'}>
                {tile.label}
              </Typography>
              <Typography variant={'h4'}>
                {isLoading ? <Skeleton width={64} /> : tile.value}
              </Typography>
            </FlexBox>
          </Fragment>
        ))}
      </FlexBox>

      {children}
    </FlexBox>
  </Card>
);

export default EngagementCard;
